export default "__VITE_ASSET__CGNL25qJ__"